import { WorkerProfile } from 'src/DTO/WorkerProfile.type';
import { calcAge } from './calcAge';

export const getWorkerNameWithAge = (worker: WorkerProfile) =>
  worker.birthDay ? `${worker.name} (${calcAge(new Date(worker.birthDay))})` : worker.name;
